import { onCLS, onLCP, onINP, onFCP, onTTFB } from 'web-vitals/attribution';
import Logger from './logger';

function logMetric({ name, value, id, attribution, rating }) {

	let eventParams = {
		metric_id: id,
		metric_name: name,
		metric_value: value,
		metric_rating: rating,
		metric_target: null,
	};

	switch (name) {
		case 'CLS':
			eventParams.metric_target = attribution.largestShiftTarget;
			break;
		case 'INP':
			eventParams.metric_target = attribution.interactionTarget;
			break;
		case 'LCP':
			eventParams.metric_target = attribution.element;
			break;
	}

	pushToAppInsights(eventParams);

}

function pushToAppInsights(eventData: any) {
	Logger.trackEvent('web-vitals', eventData);
}

export function initMetricLogging() {
	onCLS(logMetric);
	onLCP(logMetric);
	onINP(logMetric);
	onFCP(logMetric);
	onTTFB(logMetric);
}
